import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Box } from 'fw/components';
import * as Notifications from 'fw/globals/Notifications'

class NotificationsDemo extends React.Component {

	success = () => {
		Notifications.success("This is a success message.");
	}

	error = () => {
		Notifications.error("This is an error message.");
	}

	render() {
		return (
			<Box title="Notifications">
				<Row>
					<Col md={12}>
						<Button bsStyle="primary" onClick={this.success}>Success</Button>
						<Button bsStyle="danger" onClick={this.error}>Error</Button>
					</Col>
				</Row>
			</Box>
		)
	}
}

export default NotificationsDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Modals/NotificationsDemo.js